const analyticsEvents = {
  loginPage: 'Login page',
  createAccountLinkClick: 'Login page create account link click', // added by request from Katrin Gribova
  registerPage: 'Register page', // SCNT-3081
  registerFailed: 'Signup failed', // SCNT-5216

  scentbirdLogoClick: 'Scentbird logo click', // SB-1481
  changeFrequencyClick: 'Change frequency click', // SCNT-1456
  unsubscribeClick: 'Unsubscribe click', // SCNT-1456
  skipMonthClick: 'Skip month click', // SCNT-1456
  unsubscribe: 'Unsubscribe choose option', // SCNT-3460
  upgradePopup: 'Upgrade popup', // SCNT-1456
  pageVisit: {
    howItWorks: 'How it works page', // SCNT-2276
    upgrade: 'Upgrade page', // SCNT-3508
    downgrade: 'Downgrade page', // SCNT-3553
    cardUpdate: 'Card update page', // SCNT-1913
    productPage: 'Product page', // SCNT-4194
    productPageLanding: 'Product page landing', // SSR-54
    queuePage: 'Queue page', // SCNT-4431
    popupShop: 'Sb nym popup shop', // SCNT-4517
    planPage: 'Plan page', // SCNT-5000
    incubatorPage: 'Incubator page', // SCNT-5200
    skincareIntroPage: 'Skincare intro page', // SCNT-5543
    flashSale: 'Flash sale page', // SCNT-6360
    caseMonthlyPage: 'Case monthly page', // by request from @sergei
    thankYou: 'Thank you page', // SB-206
    freeTrial: 'free trial page', // SB-329
    emailLanding: 'Email landing page', // SB-1313
    main: 'Main page', // SB-1599
  },
  prepaidCardUpgradePopup: 'Prepaid card upgrade popup', // SCNT-2390
  stopUnsubscribePopup: 'Stop unsubscribe popup', // SCNT-2372
  stopUnsubscribe: 'Stop unsubscribe', // SCNT-2372
  twoThreeScents: '2-3 scents upgraded popup', // SCNT-2416 TODO remove it?
  resubscribeButton: 'Resubscribe button',
  resubscribePopup: {
    getBackTogether: 'Popup1', // SCNT-2563
    resubscribeWithDiscount: 'Popup2', // SCNT-2563
    postCancel: 'Resubscribe post cancel popup', // SCNT-2947
  },
  couponsPage: 'Coupon page', // SCNT-3922
  giftsetPage: 'Giftset main', // SCNT-2611
  giftsetAddToCart: 'Giftset add to cart', // SCNT-2611
  submitReview: 'Submit review', // SCNT-2627
  incubatorSubmitReview: 'Incubator submit review', // SCNT-6023
  reviewPopup: 'Review popup', // SCNT-2627
  quiz: {
    recommender: 'Recommender', // SCNT-2798
    step1: 'Quiz', // SCNT-2795
    step2: 'Quiz step 2', // SCNT-2795
    step3: 'Quiz step 3', // SCNT-2795
    step4: 'Quiz step 4', // SCNT-6071
    step5: 'Quiz step 5', // SCNT-6071
  },
  acQuiz: { // SB-8
    step0: 'Ac quiz step 1',
    step1: 'Ac quiz step 2',
    step2: 'Ac quiz step 3',
    step3: 'Ac quiz step 4',
    initial: 'Ac quiz start page',
    bannerClick: 'Ac quiz banner click',
    introPageSelectOption: 'Ac quiz intro page select option',
    fullListClick: 'Ac quiz full product list button click',
    registrationPage: 'Ac quiz registration',
    pickPage: 'Ac quiz pick page',
  },
  shareLinkClick: 'Share link click', // SCNT-3033
  invitePage: 'Invite page', // SCNT-2882
  visitPopup: 'Visit popup', // SCNT-5276
  visitPopupClick: 'Visit popup click', // SCNT-5276
  visitBanner: 'Visit banner ', // SCNT-5276
  visitBannerClick: 'Visit banner click', // SCNT-5276
  thankYouPointerClick: 'Thank you arrow click', // SCNT-4356
  thankYouAddToQueue: 'Thank you add to queue', // SCNT-3095
  popupLipBalms: 'Popup lip balm', // SCNT-3303
  popupMakeup: 'Popup makeup', // SCNT-3952
  popupSkincare: 'Skincare popup', // SCNT-5297
  popupSkincareClick: 'Skincare popup click', // SCNT-5297
  paymentPage: 'Payment page', // SCNT-3234
  paymentPageForm: 'Payment page form', // vero
  paymentForm: {
    couponCode: 'Payment form coupon code', // SCNT-4008
    method: 'Payment form method', // SCNT-4008
    firstName: 'Payment form first name', // SCNT-4008
    lastName: 'Payment form last name', // SCNT-4008
    autocomplete: 'Payment form autocomplete', // SCNT-4008
    street: 'Payment form street address', // SCNT-4008
    apt: 'Payment form apt', // SCNT-4008
    zipCode: 'Payment form zip', // SCNT-4008
    billingZipCode: 'Payment form billing zip', // SCNT-6192
    city: 'Payment form city', // SCNT-4008
    state: 'Payment form state', // SCNT-4008
    telephone: 'Payment form phone number', // SCNT-4008
    facebookMessenger: 'Payment form messenger', // SCNT-4008
    billingAddress: 'Payment form billing address', // SCNT-4008
    cardNumber: 'Payment form card number', // SCNT-4008
    holderName: 'Payment form card name', // SCNT-4008
    expDate: 'Payment form card date', // SCNT-4008
    cvc: 'Payment form card cvv', // SCNT-4008
    placeOrder: 'Place order', // SCNT-3234
  },
  quickViewButton: 'Quick view button',
  addTo: {
    queue: 'Add to queue front', // SCNT-3221
    cart: 'Add to cart', // SCNT-3221
  },
  recommendationPopup: {
    queue: 'Recommendation popup queue', // SCNT-3173
    cart: 'Recommendation popup cart', // SCNT-3173
  },
  addressValidationPopup: {
    open: 'Address validation popup', // SCNT-3192
    close: 'Close address verification', // SCNT-3192
    click: 'Address validation click', // SCNT-3192
  },
  selectPlan: [
    'Select 1 product', // SCNT-3308
    'Select 2 products', // SCNT-3308
    'Select 3 products', // SCNT-3308
  ],
  referrerLandingPageURL: 'Referrer landing page URL', // SCNT-3347
  trackingNumberClick: 'Tracking number click', // SCNT-3497
  cardFailed: 'AB card filed 309 discount popup', // SCNT-3148
  downgrade: 'Downgrade', // SCNT-3553
  pickPage: {
    main: 'Pick page', // SCNT-3574
    description: 'Pick page description', // SCNT-3683
    queue: 'Pick page submit to the queue', // SCNT-3683
    showDetails: 'Pick page show details', // SCNT-5543
  },
  blog: 'Blog', // SCNT-3599
  searchSuggestionClicked: 'Search suggestion clicked', // SCNT-4068
  profileOrderStatusProduct: 'Profile order status product', // SCNT-4040
  trackingPage: { // SCNT-4026
    main: 'Tracking number page', // SCNT-4026
    addAll: 'Tracking page add all', // SCNT-4026
    getRecommendations: 'Tracking page get recommendations', // SCNT-4026
    collections: 'Tracking page reco blocks', // SCNT-4288
    swipeProductsCarousel: 'Tracking page swipe products carousel',
  },
  fragranceFinderPage: 'Fragrance finder page', // SCNT-4004
  popularInStatesPage: 'Popular in states page', // SCNT-3853
  collectionContinue: 'Collection continue', // SCNT-3910
  collectionAddToQueueButton: 'Collection add to queue button', // achumakov 10.06.19
  homePageSliderClick: 'Home page slider click', // SB-1448
  notificationClick: 'Notification click', // no issue, @Sergey Bugorkov asked
  notificationCloseClick: 'Notification close click', // no issue, @Sergey Bugorkov asked
  faqLinkClick: 'Faq link click', // SCNT-4849
  noteClick: 'Note click', // SCNT-4904

  premiumProducts: {
    optOutPremiumPopup: 'Opt out premium popup', // SCNT-4526
  },

  mainPageLoginClick: 'Main page login click', // SCNT-5312

  newSubscribe: { // SCNT-5105, SCNT-6038
    shippingStep: 'Shipping page',
    submitShipping: 'Submit shipping',
    reviewStep: 'Payment page',
    placeOrder: 'Place order',
    summaryPage: 'Summary page', // SB-23
  },

  recurlyPayment: {
    paymentPage: 'Payment page',
  },

  cancelFlow: { // SCNT-5453
    flowStart: 'Unsubscribe flow start',
    selectReason: 'Select unsubscribe reason',
    changedMind: 'Changed mind',
    resubscribeNps: 'Resubscribe nps',
    feedback: { // SCNT-6188
      activate: 'Feedback form activated',
      send: 'Feedback form send',
    },
    pageVisit: 'Unsubscribe flow page', // SCNT-6340
  },

  cancelOffer25off: { // SCNT-6121
    start: 'Unsubscribe offer start',
    popup: 'Unsubscribe offer popup',
    accept: 'Unsubscribe offer accept',
  },

  subscribeButtonClick: 'Subscribe button click', // SCNT-5342

  applePayButton: 'ApplePay button', // SCNT-6009

  tossIn: {
    visit: 'Toss in page',
    continue: 'Toss in continue',
    purchase: 'Toss in continue popup click',
  },

  tossInPopUp: {
    click: 'Toss in pop-up click',
    appear: 'Toss in pop-up appear',
  },

  buyQueue: { // SCNT-6028
    visit: 'Buy queue page',
    add: 'Buy queue add to cart',
    continue: 'Buy queue continue',
    purchase: 'Buy queue continue popup click',
    click: 'Buy queue click', // SB-160
  },

  concept: { // SCNT-6161
    click: 'Concept click',
    view: 'Concept view',
    viewAction: 'Concept view action',
    vote: 'Concept vote',
    banner: 'Concept banner click',
  },

  surveyForm: { // SCNT-6253
    page: 'Customer survey form page',
    banner: 'Customer survey form banner',
  },

  changeGender: 'Change gender', // SCNT-5577

  casesSubscription: { // SB-9
    main: 'Case sub page',
    choose: 'Case sub page choose',
    remove: 'Case sub page remove',
    decline: 'Case sub page decline',
  },

  mix: { // SCNT-6345
    newPage: 'Mix new page',
    mainPage: 'Main mix page', // SCNT-6364
    productClick: 'Mix product click', // SCNT-6364
    burgerMenuLinkClick: 'Mix burger menu link click', // SCNT-6364
    subHeaderLinkClick: 'Mix sub header link click', // SCNT-6365
  },

  flashSale: { // SCNT-6360
    popup: 'Flash sale popup',
    popupClick: 'Flash sale popup click',
  },

  tech: {
    beginStart: 'Tech begin start',
    beginSuccess: 'Tech begin success',
    beginError: 'Tech begin error',
    commitStart: 'Tech commit start',
    commitSuccess: 'Tech commit success',
    commitError: 'Tech commit error',
    callVindiciaStart: 'Tech callVindicia start',
    callVindiciaSuccess: 'Tech callVindicia success',
    callVindiciaError: 'Tech callVindicia error',
    beginPaypal: 'Tech beginPaypal',
    commitPaypal: 'Tech commitPaypal',
    beginApplePay: 'Tech beginApplePay',
    commitApplePay: 'Tech commitApplePay',
    syncUserAndSubscription: 'Tech syncUserAndSubscription',
    buyGiftCard: 'Tech buyGiftCard',
    buyGiftSubscription: 'Tech buyGiftSubscription',
    buyOrder: 'Tech buyOrder',
    buySubscription: 'Tech buySubscription',
    postponedSubscriptionProcessing: 'Tech postponedSubscriptionProcessing',
    recursionSubscriptionProcessing: {
      done: 'Tech recursionSubscriptionProcessing done',
    },
    redeemCoupon: 'Tech redeemCoupon',
    redeemCouponNoCharge: 'Tech redeemCouponNoCharge',
    redeemGiftSubscription: 'Tech redeemGiftSubscription',
  },

  improveRecommendations: {   // SCNT-6413
    start: 'Recommendations improve start',
    finish: 'Recommendations improve finish',
    like: 'Recommendations improve like',
    dislike: 'Recommendations improve dislike',
  },

  newThankYouPage: {
    goToCatalogClick: 'Thank you go to catalog click',
    upgradeOptionClick: 'Thank you upgrade option click',
    upgradeContinueClick: 'Thank you upgrade continue click',
  },

  upgradeProductPage: {   // SB-79
    visit: 'Upgrade product page',
    upgradeOptionClick: 'Upgrade product option click',
    upgradeContinueClick: 'Upgrade product continue click',
    goToCatalogClick: 'Upgrade product go to catalog click',
  },

  upgradeSliderBanner: {  // SB-211
    upgradeOptionClick: 'Upgrade slider click',
    upgradeContinueClick: 'Upgrade slider continue click',
    goToCatalogClick: 'Upgrade slider go to catalog click',
  },

  caseSubscriptionPage: {   // SB-154
    visit: 'Case subscription page',
    click: 'Get case button click',
  },

  promote: { // SB-121
    buyQueue: 'Buy queue click',
    casesBanner: 'Cases banner click',
    subscriptionUpgrade: 'Subscription upgrade click',
  },

  personalReferral: 'Personal referral page', // SB-106
  profileMenuMobile: 'Profile menu mobile', // SB-253
  openQueueClick: 'Open queue click ', // SB-1416

  subscribeNowLinkClick: 'Subscribe now link click', // SB-1933
}


export default analyticsEvents
